module.exports = __webpack_public_path__ + "static/maximize-image-8130d1818ea9df9e2dfe75fa28fa1f19.png";